module.exports = __webpack_public_path__ + "assets/img/role-upset.488ecd08.png";